import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import dayjs from 'dayjs';
import emitter from '@/util/emitter.js'
// 筛选条件示例
// {
//     "startDate": 202401,
//     "endDate": 202412,
//     "brandCode": "BRAND001",
//     "familyCode": "DEP001",
//     "indicationCode": "DIV001",
//     "bu": "BU001",
//     "subBu": "SUBBU001",
//     "rsd": "RSD001",
//     "rsm": "RSM001",
//     "dsm": "DSM001",
//     "mr": "MR001"
// }

export const useFilterStore = defineStore('filter', () => {

  //计算预设YTD的时间区间
  const calculateYTDRange = () => {
    const currentDate = dayjs();
    const currentMonth = currentDate.month() + 1; // 转换为1-12月
    const currentYear = currentDate.year();

    let startDate;
    // 处理1月份特殊情况
    if (currentMonth === 1) {
      const lastYear = currentYear - 1;
      startDate = parseInt(`${lastYear}01`);
    } else {
      startDate = parseInt(`${currentYear}01`);
    }

    // 结束时间为当前月份
    const endDate = parseInt(currentDate.format('YYYYMM'));

    // 直接返回计算结果
    return {
      startDate,
      endDate
    };
  }

  const startDate = ref(calculateYTDRange().startDate);
  const endDate = ref(calculateYTDRange().endDate);
  const brandCode = ref(null);
  const familyCode = ref(null);
  const indicationCode = ref(null);
  const bu = ref(null);
  const subBu = ref(null);
  const rsd = ref(null);
  const rsm = ref(null);
  const dsm = ref(null);
  const mr = ref(null);



  // 重置函数使用初始值进行重置
  const resetFilter = () => {
    startDate.value = parseInt(calculateYTDRange().startDate);
    endDate.value = parseInt(calculateYTDRange().endDate);
    brandCode.value = null;
    familyCode.value = null;
    indicationCode.value = null;
    bu.value = null;
    subBu.value = null;
    rsd.value = null;
    rsm.value = null;
    dsm.value = null;
    mr.value = null;
  }
  const resetStructure = () => {
    bu.value = null;
    subBu.value = null;
    rsd.value = null;
    rsm.value = null;
    dsm.value = null;
    mr.value = null;
  }
  const resetBrand = () => {
    brandCode.value = null;
    familyCode.value = null;
    indicationCode.value = null;
  }
  // 数据变更后调用emitter
  watch([startDate, endDate, brandCode, familyCode, indicationCode, bu, subBu, rsd, rsm, dsm, mr],
    ([startDate, endDate, brandCode, familyCode, indicationCode, bu, subBu, rsd, rsm, dsm, mr]) => {
      emitter.emit('filter-change', {
        startDate,
        endDate,
        brandCode,
        familyCode,
        indicationCode,
        bu,
        subBu,
        rsd,
        rsm,
        dsm,
        mr
      })
    })

  return {
    startDate,
    endDate,
    brandCode,
    familyCode,
    indicationCode,
    bu,
    subBu,
    rsd,
    rsm,
    dsm,
    mr,
    resetFilter,
    resetStructure,
    resetBrand
  }
})
